// extracted by mini-css-extract-plugin
module.exports = {"hide":"ScreenReaderHidden_hide__XBq65"};